import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Halaman auto-login untuk employee dari TEMA.
 *
 * Flow:
 * 1. TEMA redirect ke: /auth/tema?tema_api_key=xxx&tema_user_id=emp_001&name=Budi&email=budi@co.com&phone=08xxx&rso=JABODETABEK
 * 2. Halaman ini baca query params, call employeeLogin()
 * 3. Sukses → redirect /employee/reports
 * 4. Gagal → tampil pesan error
 *
 * Endpoint: POST /api/v1/auth/tema/employee-login
 *   body: { tema_api_key, tema_user_id, name?, email?, phone?, rso? }
 *
 * Contoh URL:
 * http://192.168.0.167:3000/auth/tema?tema_api_key=tema_key_exel_123456&tema_user_id=emp_001&name=Budi+Santoso&email=budi@company.com&phone=08123456789&rso=JABODETABEK
 */
const TemaAuthPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { employeeLogin } = useAuth();
  const [error, setError] = useState('');
  const calledRef = useRef(false);

  useEffect(() => {
    // Guard terhadap StrictMode double-invocation di development
    if (calledRef.current) return;
    calledRef.current = true;

    const tema_api_key = searchParams.get('tema_api_key');
    const tema_user_id = searchParams.get('tema_user_id');
    const name         = searchParams.get('name') || undefined;
    const email        = searchParams.get('email') || undefined;
    const phone        = searchParams.get('phone') || undefined;
    const rso          = searchParams.get('rso') || undefined;

    if (!tema_api_key || !tema_user_id) {
      setError('Parameter tidak lengkap. Akses halaman ini melalui platform TEMA.');
      return;
    }

    employeeLogin({ tema_api_key, tema_user_id, name, email, phone, rso })
      .then(() => {
        navigate('/employee/reports', { replace: true });
      })
      .catch((err) => {
        setError(err?.message || 'Login gagal. Hubungi administrator.');
      });
  }, []); // sengaja kosong: hanya run sekali saat mount

  if (error) {
    return (
      <div className="lp">
        <div className="lp__circle lp__circle--1" />
        <div className="lp__circle lp__circle--2" />
        <div className="lp__hero">
          <div className="lp__logo-wrap"><span className="lp__logo">👕</span></div>
          <h1 className="lp__title">TEMA Report</h1>
        </div>
        <div className="lp__sheet">
          <div className="lp__error" style={{ marginBottom: 0 }}>
            <span>⚠️</span> {error}
          </div>
          <p style={{ fontSize: 13, color: '#6b7280', marginTop: 16, textAlign: 'center' }}>
            Silakan masuk melalui platform TEMA Anda.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="lp">
      <div className="lp__circle lp__circle--1" />
      <div className="lp__circle lp__circle--2" />
      <div className="lp__hero">
        <div className="lp__logo-wrap"><span className="lp__logo">👕</span></div>
        <h1 className="lp__title">TEMA Report</h1>
        <p className="lp__subtitle">Memverifikasi akun Anda…</p>
      </div>
      <div className="lp__sheet" style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', minHeight: 100 }}>
        <span className="lp__spinner" style={{ width: 32, height: 32, borderWidth: 3 }} />
      </div>
    </div>
  );
};

export default TemaAuthPage;
